var _path, _path2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5078 32.4668C35.0885 32.4668 33.9492 31.998 33.0898 31.0605C32.2305 30.123 31.8008 28.8763 31.8008 27.3203C31.8008 25.7643 32.2305 24.5208 33.0898 23.5898C33.9557 22.6523 35.1016 22.1836 36.5273 22.1836C37.6927 22.1836 38.6758 22.4896 39.4766 23.1016C40.2839 23.707 40.7852 24.5729 40.9805 25.6992H38.7441C38.373 24.6185 37.6276 24.0781 36.5078 24.0781C35.707 24.0781 35.082 24.3581 34.6328 24.918C34.1901 25.4779 33.9688 26.2786 33.9688 27.3203C33.9688 28.362 34.1901 29.1628 34.6328 29.7227C35.082 30.2826 35.707 30.5625 36.5078 30.5625C37.6862 30.5625 38.4382 29.9766 38.7637 28.8047H41C40.7786 29.9505 40.2676 30.849 39.4668 31.5C38.666 32.1445 37.6797 32.4668 36.5078 32.4668Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9478 32.4668C26.3097 32.4668 25.7563 32.3561 25.2876 32.1348C24.8188 31.9069 24.3794 31.5423 23.9692 31.041V32.2422H21.9087V18.2383H24.0864V23.5801C24.4901 23.0918 24.9165 22.737 25.3657 22.5156C25.8215 22.2943 26.3553 22.1836 26.9673 22.1836C28.2954 22.1836 29.3566 22.6523 30.1509 23.5898C30.9517 24.5208 31.352 25.7643 31.352 27.3203C31.352 28.8763 30.9517 30.123 30.1509 31.0605C29.3501 31.998 28.2824 32.4668 26.9478 32.4668ZM24.0278 27.3203C24.0278 28.362 24.2524 29.1628 24.7017 29.7227C25.1574 30.2826 25.7922 30.5625 26.606 30.5625C27.4198 30.5625 28.0513 30.2826 28.5005 29.7227C28.9562 29.1628 29.1841 28.362 29.1841 27.3203C29.1841 26.2721 28.9595 25.4714 28.5103 24.918C28.061 24.3581 27.4263 24.0781 26.606 24.0781C25.7856 24.0781 25.1509 24.3581 24.7017 24.918C24.2524 25.4714 24.0278 26.2721 24.0278 27.3203Z",
    fill: "#522D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 32.2422L14.2246 18.2383H16.5195L21.7441 32.2422H19.3613L18.082 28.6777H12.584L11.3438 32.2422H9ZM13.3066 26.666H17.3594L15.3184 20.9434L13.3066 26.666Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIconSelected);
export default __webpack_public_path__ + "static/media/Name_icon_selected.74f29b57b37fc69d9f5a6703608fdacc.svg";
export { ForwardRef as ReactComponent };